// Seletor de múltiplos documentos (imagem ou PDF) do falecido — não faz upload, só gerencia a seleção local
import RoundedInput from "./RoundedInput";

const labelStyle = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 13,
  fontWeight: 600,
  color: "#888",
  marginBottom: 4,
  paddingLeft: 12,
  display: "block",
};

function DocumentUploader({
  inputId = "documento-upload",
  label = "Documentos do falecido",
  files,
  onChange,
  descricoes,
  onDescricoesChange,
}) {
  return (
    <div>
      <label style={labelStyle}>{label}</label>

      <label
        htmlFor={inputId}
        style={{
          width: "100%",
          minHeight: 90,
          borderRadius: 24,
          border: "2px dashed #d0d0d0",
          background: "#f4f4f4",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          padding: 20,
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 6,
          }}
        >
          <div style={{ fontSize: 28 }}>📄</div>

          <span
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 14,
              color: files.length ? "#555" : "#999",
              textAlign: "center",
              wordBreak: "break-word",
            }}
          >
            {files.length
              ? `${files.length} arquivo(s) selecionado(s)`
              : "Clique para enviar documentos (imagem ou PDF)"}
          </span>
        </div>
      </label>

      <input
        id={inputId}
        type="file"
        accept=".jpg,.jpeg,.png,.pdf"
        multiple
        style={{ display: "none" }}
        onChange={(e) => {
          const selected = Array.from(e.target.files || []);
          if (selected.length) {
            onChange([...files, ...selected]);
            onDescricoesChange?.([
              ...(descricoes || []),
              ...selected.map(() => ""),
            ]);
          }
          e.target.value = "";
        }}
      />

      {files.length > 0 && (
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            margin: "10px 0 0",
            display: "flex",
            flexDirection: "column",
            gap: 6,
          }}
        >
          {files.map((file, idx) => (
            <li
              key={`${file.name}-${idx}`}
              style={{
                background: "#f4f4f4",
                borderRadius: 12,
                padding: "8px 14px",
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 13,
                color: "#555",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ wordBreak: "break-word" }}>{file.name}</span>
                <span
                  onClick={() => {
                    onChange(files.filter((_, i) => i !== idx));
                    onDescricoesChange?.(
                      (descricoes || []).filter((_, i) => i !== idx),
                    );
                  }}
                  style={{
                    cursor: "pointer",
                    color: "#999",
                    fontWeight: 700,
                    marginLeft: 10,
                    flexShrink: 0,
                  }}
                >
                  ×
                </span>
              </div>
              {onDescricoesChange && (
                <RoundedInput
                  placeholder="Tipo ou descrição do documento (opcional)"
                  value={descricoes?.[idx] || ""}
                  onChange={(e) =>
                    onDescricoesChange(
                      (descricoes || []).map((d, i) =>
                        i === idx ? e.target.value : d,
                      ),
                    )
                  }
                  style={{
                    marginTop: 6,
                    padding: "8px 14px",
                    fontSize: 13,
                  }}
                />
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default DocumentUploader;
